import pluralize from 'pluralize';
import { ReportingControllerBaseConfig } from '../../../base';
import { ContentOverlayController } from './contentOverlayInterface';
import { capitalize } from 'lodash';
import { assert } from '@varos/util-typescript';
import { ContentOverlayViewProps } from './contentOverlayProps';

export function createContentOverlayController(
    config: ReportingControllerBaseConfig
): ContentOverlayController {
    return {
        useProps(context, item, props): ContentOverlayViewProps {
            assert(item.content.markdown, 'expected markdown to be set on system source');
            return {
                breadcrumb: {
                    items: [
                        ...(item.content.type
                            ? [
                                  {
                                      id: 'type',
                                      label: capitalize(
                                          pluralize(
                                              item.content.type.replaceAll('-', ' ')
                                          )
                                      ),
                                      isActive: false,
                                      link: null,
                                  },
                              ]
                            : []),
                        {
                            id: 'provider',
                            label: 'Varos',
                            isActive: false,
                            link: null,
                        },
                        {
                            id: item.content.id,
                            label: item.content.name,
                            isActive: true,
                            link: null,
                        },
                    ],
                },
                content: {
                    title: item.content.name,
                    markdown: item.content.markdown,
                    author: {
                        label: item.author.name,
                    },
                    duration: {
                        label: 'Less than 5 min read',
                    },
                    timestamp: {
                        absolute: item.content.publishedAt.toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                        }),
                    },
                },
                references: item.content.references.map((reference, index) => ({
                    id: reference.id,
                    number: index + 1,
                    label: reference.name,
                    author: reference.author,
                    year: reference.year,
                    publisher: reference.publisher,
                    anchor: reference.url
                        ? {
                              href: reference.url,
                              id: reference.id,
                          }
                        : null,
                })),
            };
        },
    };
}
